import "./GameViews/gameViews.css";
import {Component} from 'react';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import ConfigFile from "../../datasets/config_file";
import {doubleToStringMonthly} from '../../objects/CommonUse/double_functions';
import { setHeadersForFetch } from '../../objects/CommonUse/set_headers_for_fetch';
import {calcNbrMonthsBtwnDates} from '../../objects/CommonUse/nbr_months_btwn_dates_calc';
import { createSalaryAsset } from '../../objects/AssetsExpenses/create_salary_asset';
import { createTaxAmtExpense } from '../../objects/AssetsExpenses/create_tax_amt_expense';
import { createHealthInsExpense } from '../../objects/AssetsExpenses/create_health_ins_expense';
import {calculateJobSalary} from '../../objects/AssetsExpenses/calculate_job_salary';
import { replaceTextInString } from "../../objects/CommonUse/replace_text_in_string";
import TwoColumnTableCard from "./two_column_table_card";
import createMoodPointArr from "../shared-components/objects/create_mood_point_arr";
import determineMoodPoints from "../../objects/CommonUse/determine_mood_points";
import WaitTimeSpinner from "../shared-components/wait_time_spinner";
import {buildUrl } from '../../objects/CommonUse/build_URL';
import Config from '../../config';
import { reformatDateToDisplay } from "../../objects/CommonUse/reformatDateToDisplay_function";
import createPendingJobObj from "./objectsJob/create_pending_job_obj";
import createConditionTableObject from "./objectsJob/create_condition_table_object";
import createNewLoanTableObject from "./objectsJob/create_new_loan_table_object";
import calculateYearsOfCollege from "./objectsJob/calculate_years_of_college";
import determineIfStepStoneJob from "./objectsJob/determine_if_step_stone_job";

class CareerChangeModal extends Component {
  constructor(props) {
    super(props);
    this.gameInfo = this.props.gameInfo();
    this.state={
         headers: setHeadersForFetch(),
         loadingCareerData: true,
         careerDataSw: false,
         openFriendModal: false,
         pendingJobObj: {},
         expandStepStoneText: false,
         subProcess: "careerChangeModal",
         environment: Config.dataURL.currentEnv,
    }; 
    this.careerData = null;
    this.newAssetTable = [];
    this.newExpenseTable = [];
    this.newLoanTable = [];
    this.newConditionsTable = [];
    this.collegeLoanTable = [];
    this.relatedCareers = [];
    this.pendingJobObj = {};
    this.totalMoodPoints = 0;
    this.currentJob = {careerID: "", jobSalary: 0, annualJobSalary: 0, healthInsInd: ""};
    this.newJob = {careerID: "", careerName: "", jobSalary: 0, annualSalary: 0, nbrYearsCollege: 0,
        degreeType: "", degreeSpecialty: "", healthInsInd: "", jobRank: "",
        jobStartDate: ""
    };
    this.getCurrentCareerData();   
  }

  determineIfPendingJob(){
      if (this.gameInfo.gameData.pendingJob ){
          this.modalType = "PendingJob";
      }  
  }

  determineCareerChangeAmts(){
      this.getNewCareerData();
      this.getGameData();
            
      if (this.currentJob.careerID  ===  this.newJob.careerID )  {  
          this.modalType = "SameCareer";
      }else{ 
          this.modalType = "NewCareerInfo"
          this.createNewTableObjects();
      }
  }
  
  getNewCareerData() {
      this.newJob.careerID  = sessionStorage.getItem("careerChoice");
      this.newJob.careerName  = sessionStorage.getItem("careerName");
      this.newJob.jobSalary  = sessionStorage.getItem("salary");
      this.checkPrevJobArr();
      if (+this.newJob.jobSalary  < +this.currentJob.jobSalary){
           this.newJob.jobSalary  = this.currentJob.jobSalary;
      }
      this.newJob.annualSalary = this.newJob.jobSalary * 12;
      this.newJob.nbrYearsCollege = +JSON.parse(JSON.stringify(sessionStorage.getItem("jobNbrYearsCollege")));
      this.newJob.degreeType  = sessionStorage.getItem("jobDegreeType");
      this.newJob.degreeSpecialty  = sessionStorage.getItem("jobDegreeSpecialty");
      this.relatedCareers  = JSON.parse(sessionStorage.getItem("careerRelatedCareers"));
      this.newJob.healthInsInd = sessionStorage.getItem("jobHealthInsInd");
      this.newJob.jobRank = sessionStorage.getItem("jobRank");
  }

  checkPrevJobArr(){
      this.currentJob.jobSalary = 0;
      this.hadJobPreviously = false;
      this.nbrYearsSinceJob = 9999;
      if (this.gameInfo.gameData.jobInfo.prevJobArr ){
        let prevJobObj = undefined;
        let startIndx = this.gameInfo.gameData.jobInfo.prevJobArr.length - 1;
        for (let i=startIndx; i>=0; i--){
            let prevJobArr = this.gameInfo.gameData.jobInfo.prevJobArr[i];
            if (prevJobArr.previousJobName === this.newJob.careerName ){ 
                prevJobObj = prevJobArr;
                break;
            }
        }  
        if (prevJobObj ){
            this.hadJobPreviously = true;
            const nbrMonthsSinceJob = calcNbrMonthsBtwnDates(prevJobObj.jobEndDate, 
              this.gameInfo.gameData.currentGameDate);
            this.nbrYearsSinceJob = (+nbrMonthsSinceJob / 12).toFixed(0);
            // salary reduced by 10% for each year after last had job
            const salaryReduction = (100 - (+this.nbrYearsSinceJob * 10))/100;
            this.currentJob.jobSalary = (prevJobObj.monthlySalary * salaryReduction).toFixed(2);
        }
      }
  }

  getGameData() {
      const gameData = JSON.parse(JSON.stringify(this.gameInfo.gameData));
      this.loanTable = gameData.loanTable;
      this.currentGameDate = gameData.currentGameDate; 
      this.assetTable = gameData.assetTable;
      this.expenseTable = gameData.expenseTable;
      this.newConditionsTable = gameData.conditionsTable;
      this.totalGameNbrYearsCollege = +gameData.jobInfo.nbrYearsCollege;
      this.startGameDate = gameData.startGameDate;
      this.currentJob.jobSalary = calculateJobSalary(this.assetTable, this.currentGameDate, true);
      this.currentJob.annualJobSalary = +this.salary * 12;
      this.currentJob.healthInsInd = gameData.jobInfo.healthInsInd;
  }

  createNewTableObjects() {
      this.stepStoneObj = determineIfStepStoneJob(this.gameInfo.gameData.jobInfo.jobStartDate,
          this.currentGameDate, this.relatedCareers, this.currentJob.careerName,
           this.currentNbrYearsCollege, this.newJob.careerName
      )
      this.collegeObj = calculateYearsOfCollege(this.hadJobPreviously, this.nbrYearsSinceJob, 
          this.currentNbrYearsCollege, this.relatedCareers , this.currentJob.careerName , 
          this.stepStoneObj.careerNbrMonths, +this.totalGameNbrYearsCollege, this.currentGameDate, 
          this.newJob);
      this.newConditionsTable = createConditionTableObject(this.gameInfo.gameData.conditionsTable,
          this.collegeObj.adjustedNbrYearsCollege, this.newJob.careerID, this.props.conditionList );
      this.determineJobChangeMoodPoints();
      if (this.collegeObj.adjustedNbrYearsCollege === 0){
        // set the number of months remaining for current job equal to the number of months
        // required for college 
        this.newAssetTable = createSalaryAsset(this.assetTable, this.newJob.jobSalary , this.newJob.careerName ,
           this.currentGameDate, this.startGameDate);
        this.createNewExpenseTableObject();
        this.newLoanTable = this.loanTable;
      }else{
        this.loanTableObj = createNewLoanTableObject(this.collegeObj.adjustedNbrYearsCollege, this.currentGameDate, 
          this.startGameDate, this.collegeObj.actualNbrYearsCollege, this.newJob.degreeType, 
          this.newJob.degreeSpecialty, this.loanTable);
        this.newLoanTable = this.loanTableObj.loanTable;
        this.pctOfTuition = this.loanTableObj.pctOfTuition;
        this.loanDesc = this.loanTableObj.loanDesc;
        this.collegeLoanTable = this.loanTableObj.collegeLoanTable;
        this.pendingJobObj = createPendingJobObj(this.currentJob, this.newJob,
            this.collegeObj.totalNbrYearsCollege, this.collegeObj.adjustedNbrYearsCollege, this.props.conditionList,
            this.newLoanTable );
      }
  }
         
  determineJobChangeMoodPoints(){
    this.startingMoodPoints = ConfigFile.gameChoice.jobChangeMood;
    let gameChoiceArr = createMoodPointArr("job");
    this.moodPointStartArr = determineMoodPoints(gameChoiceArr);
    this.totalMoodPoints = +this.startingMoodPoints;
    for (let i=0; i<this.moodPointStartArr.length; i++){
         this.totalMoodPoints += +this.moodPointStartArr[i].number;
    }
  }
    
 createNewExpenseTableObject(){
     const taxAmtObj = createTaxAmtExpense(this.expenseTable, this.newAssetTable, 
          this.currentGameDate);   
     this.newExpenseTable = taxAmtObj.expenseTable;  
     if (this.newJob.healthInsInd !== this.currentJob.healthInsInd){
          this.expenseTable = createHealthInsExpense(this.expenseTable, this.newJob.healthInsInd,
              this.currentGameDate, this.startGameDate)
     }
  }


  render() { 
      if (this.state.careerDataSw === true) {
          this.determineCareerChangeAmts();
      }
      if (this.modalType === "NewCareerInfo"){
          if (this.collegeObj.adjustedNbrYearsCollege !== 0){
             this.collegeLoanList = this.collegeLoanTable.map((loanAmts,key) =>
              <TwoColumnTableCard key={key} infoType="date-amount-car" outInfo={loanAmts}  />
              );  
          }  
          this.moodPointList = this.moodPointStartArr.map((moodPoints,key) =>
            <TwoColumnTableCard key={key} infoType="label-number" outInfo={moodPoints}  />
          );
      }
             
  return <>
    {this.modalType === "SameCareer" ?
        <Modal show={this.props.show}  onHide={() => this.props.onClose()} size="med" scrollable="true"
            animation={false}>
          <Modal.Header className="gameChoiceModalHdrFtrBackground" closeButton>
            <Modal.Title>Career Change - Make Another Choice</Modal.Title> 
          </Modal.Header>
          <Modal.Body >
            <div>
                <p>The career that you have selected is the same as your current
                   career.  Please click on the 'close' button and then select
                   another option.
                </p>
              </div>
          </Modal.Body>
          <Modal.Footer className="gameChoiceModalHdrFtrBackground">
          <Button variant="secondary"   onClick={() => this.props.onClose()}>
               Close
            </Button>
          </Modal.Footer>
          </Modal>
    :
        null
    }

    {this.modalType === "TrainVideo"  ?
        <Modal show={this.props.show}  onHide={() => this.props.onClose()} size="med" animation={false}>
        <Modal.Body>
          <span>
              <div className="text-white mt-4">xxxxxx</div>
              <div className="text-white mt-4">xxxxxx</div>
                  <WaitTimeSpinner />
              <div className="text-white mt-4">xxxxxx</div>
              <div className="text-white mt-4">xxxxxx</div>
              <div className="text-white mt-4">xxxxxx</div>
          </span>
      </Modal.Body>
      </Modal>
    :
        null  
    }

    {this.modalType === "NewCareerInfo" ?
    <Modal show={this.props.show}  onHide={() => this.props.onClose()} size="med" scrollable="true"
        animation={false}>
      <Modal.Header className="gameChoiceModalHdrFtrBackground" closeButton>
        <Modal.Title>Cost Information for Changing Careers</Modal.Title> 
      </Modal.Header>
      <Modal.Body>
        <p className="mr-2">Here is the key information about your new career selection. 
            Click the "Continue/Accept" button to confirm that this career is a good choice
            for you.</p>  
          {this.collegeRequiredText  && this.collegeRequiredText !== "" ?
            <div className="mt-2 text-success"><b>Note:</b>&nbsp;&nbsp;{this.collegeRequiredText}</div>
          :
            null
          }
          {this.collegeObj.prevJobText  && this.collegeObj.prevJobText !== ""  ?
            <div className="mt-2 text-success"><b>Note:</b> &nbsp;&nbsp;{this.collegeObj.prevJobText}</div>
          :
            null
          }

          {this.stepStoneObj.stepStoneType !== "" ?
              <span>
                {this.state.expandStepStoneText ?
                    <div className="text-success">
                        <b>Note:&nbsp; </b> {this.stepStoneText}  &nbsp;&nbsp;&nbsp;
                        <Button variant="outline-success" size="sm"
                            onClick={() => this.collapseStepStone()}>
                                Collapse
                        </Button>
                    </div>
                    :
                    <div className="ml-2 mt-2 text-success">
                        <b>Note:&nbsp; </b> {this.stepStoneObj.shortStepStoneText} &nbsp;&nbsp;&nbsp; 
                        <Button variant="outline-success" size="sm"
                            onClick={() => this.expandStepStone()}>
                                Learn More
                        </Button>
                    </div>
              }
              </span>
          :
            null
          }  

          <div className="mt-4"></div>
          <table className="table table-hover">
               <tbody>
                  <tr>
                      <th className="text-left p-0">{this.currentJob.careerName }&nbsp;Salary</th>
                      <td className="text-right p-0">{doubleToStringMonthly(this.currentJob.jobSalary)}</td>
                  </tr>
                  <tr>
                      <th className="text-left p-0">{ this.newJob.careerName }&nbsp;Salary</th>
                      <td className="text-right p-0">{doubleToStringMonthly(this.newJob.jobSalary)}</td>
                  </tr>
                </tbody>
            </table>
            {this.collegeObj.adjustedNbrYearsCollege > 0 ?
                <table className="table table-hover">
                  <tbody className="row-100">
                    <tr>
                      <th className="text-left p-0">Pct Your Employer Will Pay toward College</th>
                      <td className="text-right p-0">{this.pctOfTuition*100}%</td>
                    </tr>
                    <tr>
                       <th className="text-left p-0">College Required for New job</th>
                       <td className="text-right p-0">{+this.newJob.nbrYearsCollege} Year(s)</td>
                    </tr>
                    <tr>
                       <th className="text-left p-0">Reduced Due To Previous College Credit</th>
                       <td className="text-right p-0">{+this.collegeObj.reducedNbrYearsCollege}&nbsp;Year(s)</td>
                    </tr>
                    <tr>
                      <th className="text-left p-0">Added time for college when working</th>
                      <td className="text-right p-0">{this.collegeObj.collegeWhenWorking} Year(s)</td>
                    </tr>
                    {this.gameInfo.gameData.currentGameDate !== this.newJob.jobStartDate ?
                      <tr>
                        <th className="text-left p-0 ">Current Game Date</th>
                        <td className="text-right p-0">
                            {reformatDateToDisplay(this.gameInfo.gameData.currentGameDate)}</td>
                      </tr>
                    :
                      null
                    }
                    <tr>
                      <th className="text-left p-0 highlight">Expected Start Date of New Job</th>
                      <td className="text-right p-0 highlight">{reformatDateToDisplay(this.newJob.jobStartDate)}</td>
                    </tr>
                   
                  </tbody>
                  <tbody className="row-100">
                    <tr>
                        <th className="text-left">----------------------------------------------</th>
                        <th className="text-center">-------------</th>
                    </tr>
                    <tr>
                       <th className="text-left p-0">{this.loanDesc}</th>
                       <td className="text-right p-0">{this.collegeObj.actualNbrYearsCollege}&nbsp;year(s)</td>
                    </tr>
                    <tr>
                       <th className="text-left">Loan Term</th>
                       <th className="text-right">Monthly</th>
                    </tr>
                          
                    {this.collegeLoanList}
                  
                  </tbody>
                </table>
             :
                null
       
              }
              <h5>Mood Point Change</h5>
              <div className="ml-2">You are so excited to be thinking about a 
                  new job.  This will add points to your mood score.
              </div>
             <table className="table table-hover">
                  <tbody className="row-100">
                    <tr>
                      <th className="text-left p-0">Description</th>
                      <th className="text-right p-0">Mood Points</th>
                    </tr>
                    <tr>
                      <th className="text-left p-0">Base Job Change Mood Points</th>
                      <th className="text-right p-0">{this.startingMoodPoints}</th>
                    </tr>
                    {this.moodPointList}
                    <tr>
                      <th className="text-left p-0">Mood Point Change</th>
                      <th className="text-right p-0">{this.totalMoodPoints}</th>
                    </tr>
                  </tbody>
            </table>
     
                               
       </Modal.Body>
        <Modal.Footer  className="gameChoiceModalHdrFtrBackground">
          <Button variant="secondary"   onClick={() => this.props.onClose()}>
              Close
          </Button>
          <Button variant="primary"  onClick={() => this.confirmCareerChange()}>
              Continue/Accept
          </Button>
        </Modal.Footer>
      </Modal>
      : 
        null
      }
    </>
  }

  componentDidMount(){
     this._isMounted = true;
  }

  componentWillUnmount(){
    this._isMounted = false;
  }
  
  expandStepStone(){
    let replaceObj = {careerName: this.newJob.careerName ,
      stepCareerName: this.stepStoneObj.stepStoneCareerName,
      nbrMonths: this.stepStoneObj.careerNbrMonths};
    this.stepStoneText = replaceTextInString(this.stepStoneObj.stepStoneFullText, replaceObj);  
    this.setState({expandStepStoneText: true});
  }

  collapseStepStone(){
      this.setState({expandStepStoneText: false});
  }

  confirmCareerChange(){
      const careerObj = {requiresCollege: this.collegeObj.requiresCollege, nbrYearsCollege: this.collegeObj.totalNbrYearsCollege,
        moodPoints: this.totalMoodPoints, conditionsTable: this.newConditionsTable,
        assetTable: this.newAssetTable, expenseTable: this.newExpenseTable, loanTable: this.newLoanTable,
        pendingJobObj: this.pendingJobObj};
      this.props.onConfirmCareerChange(careerObj);
  }

  getCurrentCareerData() {
      this.modalType = "TrainVideo";
      this.currentJob.careerID  = this.gameInfo.gameData.jobInfo.careerID; 
      const funcName = "jobInfo";
      const urlParm = "?jobId=" + this.currentJob.careerID ;
      const uri = buildUrl(this.state.environment, funcName, urlParm);
      fetch (uri,  
          {method:'GET', headers: this.state.headers})
          .then(response => {
            if (response.ok){
                response.json().then(data => {
                const output = JSON.parse(data);
                const statusCode = output.statusCode;
                if (statusCode === 200){
                    this.careerData = output.body;
                    this.currentJob.careerName  = this.careerData.jobName;
                    sessionStorage.setItem("previousJobName", this.currentJob.careerName );
                    this.currentNbrYearsCollege = this.careerData.nbrYearsCollege;
                    if (this._isMounted === true){
                      this.setState({careerDataSw: true});
                    }
                }else{
                    const errorObj={function: funcName, subProcess: this.state.subProcess, 
                        status: statusCode, message: output.body.message};
                    this.props.processError(errorObj);
                }
            });
        }
        });
  }

 
}
export default CareerChangeModal;